import { render, staticRenderFns } from "./TreeStructure.vue?vue&type=template&id=48fa382d&"
import script from "./TreeStructure.vue?vue&type=script&lang=js&"
export * from "./TreeStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports